import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home.vue"),
    meta: {
      title: "OZEANHYDRAULIK",
    },
  },
  {
    path: "/nosearch",
    name: "nosearch",
    component: () => import("../views/nosearch.vue"),
    meta: {
      title: "设备查询",
    },
  },
  {
    path: "/",
    name: "index",
    component: () => import("../views/home.vue"),
    meta: {
      title: "OZEANHYDRAULIK",
    },
  },
  {
    path: "/devices",
    name: "devices",
    component: () => import("../views/devices.vue"),
    meta: {
      title: "设备列表",
    },
  },
  {
    path: "/device_info",
    name: "device_info",
    component: () => import("../views/device_info.vue"),
    meta: {
      title: "设备信息",
    },
  },
  {
    path: "/device_detail",
    name: "device_detail",
    component: () => import("../views/device_detail.vue"),
    meta: {
      title: "设备详细信息",
    },
  },
  {
    path: "/spare_parts",
    name: "spare_parts",
    component: () => import("../views/spare_parts.vue"),
    meta: {
      title: "备件清单",
    },
  },
  {
    path: "/scene_furnace",
    name: "scene_furnace",
    component: () => import("../views/scene_furnace.vue"),
    meta: {
      title: "scene furnace",
    },
  },
  {
    path: "/magnetic",
    name: "magnetic",
    component: () => import("../views/magnetic.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/superposition",
    name: "superposition",
    component: () => import("../views/superposition.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("../views/introduce.vue"),
    meta: {
      title: "产品介绍",
    },
  },
  {
    path: "/repair",
    name: "repair",
    component: () => import("../views/repair.vue"),
    meta: {
      title: "报修",
    },
  },
  {
    path: "/record",
    name: "record",
    component: () => import("../views/record.vue"),
    meta: {
      title: "报修记录",
    },
  },
    {
    path: "/system",
    name: "system",
    component: () => import("../views/system.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/draulic",
    name: "draulic",
    component: () => import("../views/draulic.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/rcdes",
    name: "rcdes",
    component: () => import("../views/rcdes.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/rcsy",
    name: "rcsy",
    component: () => import("../views/rcsy.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/sddes",
    name: "sddes",
    component: () => import("../views/sddes.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/sdsy",
    name: "sdsy",
    component: () => import("../views/sdsy.vue"),
    meta: {
      title: "工业互联网产品溯源系统",
    },
  },
  {
    path: "/device1",
    name: "device1",
    component: () => import("../views/device1.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/device2",
    name: "device2",
    component: () => import("../views/device2.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/device3",
    name: "device3",
    component: () => import("../views/device3.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/device4",
    name: "device4",
    component: () => import("../views/device4.vue"),
    meta: {
      title: "产品溯源",
    },
  },
  {
    path: "/device5",
    name: "device5",
    component: () => import("../views/device5.vue"),
    meta: {
      title: "产品溯源",
    },
  },
]

const router = new VueRouter({
  routes,
})

export default router
